import type { AllRouteEndpoints } from "../routeTypes";
export const appsCatalogsCatalogIdFilteredSetsCacheKeys: AllRouteEndpoints[] = ["/apps/catalog_items_datatable"];
